import { graphql } from 'react-apollo'
import gql from 'graphql-tag'
import get from 'lodash.get'

export const settingsGql = gql`
  query Settings($projectId: ID!) {
    project(id: $projectId) {
      _id
      name
      url
    }
  }
`

export const settings = graphql(settingsGql, {
  options(props) {
    return {
      variables: {
        projectId: props.match.params.projectId
      },
      fetchPolicy: 'network-only'
    }
  },
  props({ data }) {
    return {
      loading: get(data, 'loading'),
      project: get(data, 'project')
    }
  }
})



// WEBPACK FOOTER //
// ./src/components/Settings/queries.js